import { useDataValue, useDataSubmit } from 'Simple/Data.js'

export function useOnChange(props) {
  let submit = useDataSubmit({
    context: 'referrals',
    viewPath: props.viewPath,
  })

  let referral_index = useDataValue({
    context: 'referral_item',
    viewPath: props.viewPath,
    path: 'index',
  })

  return function onChange(value) {
    submit({
      type: 'update_text_value',
      index: referral_index,
      text_value: value,
    })
  }
}
